<ng-container *transloco="let t">
  <div [class]="labelClass()">
    <label [id]="name() + '-label'" [for]="name()" class="text-xs font-medium text-ink tracking-tight">
      {{ t(label()) }} @if (!disabled() && required()) {
      <span class="text-danger"> *</span>
      }
    </label>
  </div>

  <div
    ngCombobox
    #combobox="ngCombobox"
    [id]="name()"
    [expanded]="popupExpanded()"
    (expandedChange)="onExpandedChange($event)"
    [disabled]="disabled()"
    [tabindex]="0"
    [attr.aria-labelledby]="name() + '-label'"
    [attr.aria-required]="required()"
    [attr.aria-busy]="pending()"
    [attr.aria-invalid]="showError()"
    [class]="appliedClasses()?.selectedClasses"
    [class.disabled]="disabled()"
    [class.input-error]="showError()"
    class="form-select juno-select__trigger"
  >
    @if (selectedOptions().length) { @for (option of visibleSelectedOptions(); track option.value) { {{ t(option.label)
    }}{{ !$last || overflowCount() > 0 ? ', ' : '' }} } @if (overflowCount() > 0) {
    <span class="juno-select__overflow">+{{ overflowCount() }} {{ t('ORDER-DETAILS.MORE') }}</span>
    } } @else {
    <span class="juno-select__placeholder">{{ placeholder() }}</span>
    }
  </div>

  <ng-template
    [cdkConnectedOverlay]="{ origin: combobox.element, usePopover: 'inline', matchWidth: true }"
    [cdkConnectedOverlayOpen]="popupExpanded()"
    (overlayOutsideClick)="onExpandedChange(false)"
  >
    <ng-template ngComboboxPopup [combobox]="combobox">
      <div
        ngListbox
        ngComboboxWidget
        #listbox="ngListbox"
        [tabindex]="-1"
        focusMode="activedescendant"
        selectionMode="explicit"
        [multi]="isMultiple()"
        [value]="listboxValue()"
        (valueChange)="onListboxValueChange($event)"
        [activeDescendant]="listbox.activeDescendant()"
        class="juno-select__popup"
        animate.enter="juno-select__popup--enter"
        animate.leave="juno-select__popup--leave"
      >
        @for (option of options(); track option.value) {
        <div ngOption [value]="option.value" [label]="t(option.label)" class="juno-select__option">
          @if (option.icon) {
          <mat-icon [class]="option.icon.iconClasses" [svgIcon]="option.icon.iconName"></mat-icon>
          }
          <span [class]="appliedClasses()?.optionClasses">{{ t(option.label) }}</span>
        </div>
        }
      </div>
    </ng-template>
  </ng-template>

  @if (showError()) {
  <!-- `role="alert"` announces the message when it appears; `aria-describedby` above ties it
         to the group for anyone who navigates back to it. WCAG 2.2 SC 3.3.1. -->
  <div [id]="controlId() + '-error'" role="alert">
    <juno-libs-ui-error [errors]="errors()"></juno-libs-ui-error>
  </div>
  }
</ng-container>
